/* eslint-disable import/no-named-as-default */
import flatten from 'lodash/flatten';
import get from 'lodash/get';
import { Route, Switch } from 'react-router-dom';

import CmsScreen from '../../cms/CmsScreen';
import NotFoundBlock from '../../components/NotFoundBlock';
import RdvOffersScreen from '../../components/rdv/RdvOffersScreen';
import RdvScreen from '../../components/rdv/RdvScreen';
import { useConfig } from '../../config/config.context';
import { useScreensConfig } from '../../config/screens.context';
import Home from '../../home/Home';
import ParticipantsScreen from '../../participants/ParticipantsScreen';
import Profile from '../../profile/Profile';
import Program from '../../programs/Program';
import Programs from '../../programs/Programs';
import SocialWallScreen from '../../social-wall/SocialWallScreen';
import Sponsor from '../../sponsors/Sponsor';
import Sponsors from '../../sponsors/Sponsors';
import { getStrings } from '../../utils';
import Workshop from '../../workshops/Workshop';
import WorkshopLive from '../../workshops/WorkshopLive';
import Workshops from '../../workshops/Workshops';

function generateRoutes(menuEntry, config) {
  const { type, name, path } = menuEntry;
  switch (type || name) {
    case 'home': {
      return [<Route key={name} path={path} exact component={Home} />];
    }
    case 'profile': {
      return [<Route key={name} path={path} exact component={Profile} />];
    }
    case 'participant-list': {
      return [<Route key={name} path={path} exact component={ParticipantsScreen} />];
    }
    case 'workshops': {
      const { workshops } = config;
      const workshopCategories = get(workshops, 'categories') || [];
      const workshopCategoriesPath = workshopCategories.map((col) => col.value).join('|');
      return [
        <Route
          key="workshops-by-collectionId"
          path={`${path}/:category(${workshopCategoriesPath})?`}
          exact
          component={Workshops}
        />,
        <Route
          key="workshops-by-slug"
          path={`${path}/:category(${workshopCategoriesPath})/:slug`}
          exact
          render={(props) => <Workshop key={props.match.slug} {...props} />}
        />,
      ];
    }
    case 'workshop-live': {
      const pageConfig = config[name];
      return [
        <Route
          key={name}
          path={path}
          exact
          render={(props) => <WorkshopLive key={props.match.slug} {...props} page={pageConfig} />}
        />,
      ];
    }
    case 'sponsors': {
      return [
        <Route key="sponsors" path={path} exact component={Sponsors} />,
        <Route
          key="sponsor"
          path={`${path}/:id`}
          exact
          render={(props) => <Sponsor key={props.match.params.id} {...props} />}
        />,
      ];
    }
    case 'programs': {
      return [
        <Route
          key="programs"
          path={path}
          exact
          render={(props) => <Programs {...props} path={path} />}
        />,
        <Route
          key="program"
          path={`${path}/:id`}
          exact
          render={(props) => <Program key={props.match.params.id} {...props} />}
        />,
      ];
    }
    case 'cms': {
      return [
        <Route
          key={name}
          path={path}
          exact
          render={(props) => <CmsScreen {...props} name={name} />}
        />,
      ];
    }
    case 'social-wall': {
      return [<Route key={name} path={path} exact component={SocialWallScreen} />];
    }
    case 'rdv': {
      return [
        <Route key="rdv" path={path} exact component={RdvScreen} />,
        <Route
          key="rdv-non-recruteur"
          path={`${path}/non-recruteur/:exhibitorId`}
          component={RdvScreen}
        />,
        <Route
          key="rdv-opportunities"
          path={`${path}/offers/:offerId?`}
          render={(props) => <RdvOffersScreen key={props.match.params.id} {...props} />}
        />,
      ];
    }
    default: {
      return [];
    }
  }
}

const PageNotFound = () => <NotFoundBlock {...getStrings('404')} />;

const DefaultRouter = () => {
  const config = useScreensConfig();
  const { menu } = useConfig();
  const routes = flatten(menu.map((menuEntry) => generateRoutes(menuEntry, config)));

  return (
    <Switch>
      {routes}
      <Route component={PageNotFound} />
    </Switch>
  );
};

DefaultRouter.propTypes = {};

export default DefaultRouter;
